import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import 'styles/index.scss';
import App from './pages/App';
import setLocale from './utils/functions/setLocale';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './utils/authConfig';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

LogRocket.init('msbcwv/kjederegisteret');
setupLogRocketReact();

// const userManager = getUserManager();

const msalInstance = new PublicClientApplication(msalConfig);

setLocale();

/*Content */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </MsalProvider>,
);

const { host } = window.location;
const useDev =
  host.indexOf('localhost') > -1 ||
  host.indexOf('kjederegisteretadmin-dev') > -1 ||
  host.indexOf('kjederegisterspadev') > -1 ||
  host.indexOf('kjederegisteretadmin-temp') > -1;
const appInsightsKey = useDev
  ? import.meta.env.VITE_DEV_INSIGHTS_KEY
  : import.meta.env.VITE_PROD_INSIGHTS_KEY;

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: appInsightsKey,
  },
});
appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((envelope) => {
  envelope.tags = envelope.tags || []; // eslint-disable-line no-param-reassign
  envelope.tags.push({ 'ai.cloud.role': 'KjederegisteretSPA' });
});

appInsights.trackPageView();
